import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import type {ITournament, ITournamentsStore} from "data/stores/tournaments/tournaments.store";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {Bindings} from "data/constants/bindings";
import type {IRoundsStore} from "data/stores/rounds/rounds.store";
import type {IMatchFilterStore} from "data/stores/match_filter_store/match_filter_store.store";
import type {ISquadsStore} from "data/stores/squads/squads.store";
import {chain, every, includes} from "lodash";

export interface IWeeklyMatchesController extends ViewController {
	readonly i18n: ILocalizationStore;

	get matchesByRoundId(): ITournament[];
	get filteredMatches(): ITournament[];
}

@injectable()
export class WeeklyMatchesController implements IWeeklyMatchesController {
	get matchesByRoundId() {
		return this._tournamentStore.tournaments.filter(
			(tournament) => tournament.roundId === this._roundStore.selectedRoundId
		);
	}

	private isListed = (match: ITournament) => {
		const {homeSquadId, awaySquadId} = match;
		const {division, squad} = this._matchFilterStore.filter;
		const homeSquad = this._squadStore.getSquadById(homeSquadId);
		const awaySquad = this._squadStore.getSquadById(awaySquadId);

		return every([
			!Number(squad) || includes([homeSquadId, awaySquadId], Number(squad)),
			!Number(division) ||
				includes([homeSquad?.divisionId, awaySquad?.divisionId], Number(division)),
		]);
	};

	get filteredMatches() {
		return chain(this.matchesByRoundId).filter(this.isListed).value();
	}
	constructor(
		@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore,
		@inject(Bindings.RoundsStore) private _roundStore: IRoundsStore,
		@inject(Bindings.TournamentsStore) private _tournamentStore: ITournamentsStore,
		@inject(Bindings.MatchFilterStore) private _matchFilterStore: IMatchFilterStore,
		@inject(Bindings.SquadsStore) private _squadStore: ISquadsStore
	) {
		makeAutoObservable(this);
	}
}
